export const DRAWING_TOOLS_TOOLTIPS = {
  SQUARE: 'Square',
  CIRCLE: 'Circle',
  PENCIL: 'Pencil (freehand)',
};

export const SLIDE_NAVIGATION_TOOLTIPS = {
  PREVIOUS: 'Previous Slide',
  NEXT: 'Next Slide',
};

export const SLIDE_ANNOTATIONS_ENABLE_TOOLTIP = 'Show/hide annotations';
export const SLIDE_MEASURE_TOOLTIP =
  "Select two points by clicking on image to measure the distance. Press 'Z' to cancel current selection.";
export const SLIDE_MEASURE_TUTORIAL_TOOLTIP = 'Measure Tool Tutorial';
export const SLIDE_ANNOTATION_TUTORIAL_TOOLTIP = 'Annotation Mode Tutorial';
